import {composeMessageFactSchema} from './ComposeMessageFactSchema';

export const composeMessageUnavailableFactSchema = composeMessageFactSchema
  .omit({value: true})
  .openapi('ComposeMessageUnavailableFact');
